import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import gtm from 'eco-design-reliance/gtm';

export default function C() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();

    const isUs = ['us'].includes(locale);
    useCardsShowHook('.cost-saving-C', '.cost-saving-C');
    return (
        <section className={`cost-saving-C GtmModuleData-section`} id="cost-saving-C" data-section-id={'cost-saving-C'} data-section-title={t('C_title')}>
            <div className={`cost-saving-C ${css['cost-saving-C']}`}>
                <EcoSpace />
                <div className="title">{t('C_title')}</div>
                <div className="desc">{t('C_desc')}</div>
                <div className="img-box">
                    <EcoImg
                        className="img"
                        isOpenLazy
                        pc="https://websiteoss.ecoflow.com/upload/image/1769508680668/Frame%2027.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1769508681032/Frame%20161269456.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1769508680826/Frame%202094654833.jpg"
                    ></EcoImg>
                    <div className="list">
                        <div className="list-left">
                            <div className="list-title">{t('C_img_title')}</div>
                            <ul>
                                <li>{t('C_img_desc1')}</li>
                                <li>{t('C_img_desc2')}</li>
                                <li>{t('C_img_desc3')}</li>
                            </ul>
                        </div>
                        <a
                            className="list-right"
                            href="https://homebattery.ecoflow.com/us/products/ocean-pro-home-solar-battery"
                            target="_blank"
                            onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    list_name: t('C_title'),
                                    product_name: t('C_title'),
                                    button_name: t('C_btn'),
                                    __btn_id1: `cost-saving-C .list-right`,
                                    __btn_id2: 'https://homebattery.ecoflow.com/us/products/ocean-pro-home-solar-battery',
                                    __btn_type: 'href',
                                });
                            }}
                        >
                            {t('C_btn')}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
